import React from "react";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";
import { getConvertedCloudUrl } from "../../../utils/image-util";

const DepotSquareAssociatedLocation = ({ t, value, index, onSelect }) => {
    const handleOnSelect = () => {
        onSelect && onSelect(index);
    }

    return (
        <div className={classNames("depotSquareAssociatedLocation", { selected: value.active })} 
            onClick={handleOnSelect}
        >
            <div className={classNames("item")}>
                {value.logoUrl && (
                    <img src={getConvertedCloudUrl(value.logoUrl, 50)} alt="img" />
                )}
                <div className={classNames("title")}>{value.businessName}</div>
            </div>
            <div className={classNames("item")}>
                <div>{value.description}</div>
            </div>
        </div>
    );
}

export default withTranslation()(DepotSquareAssociatedLocation);